import DisplayItem from './DisplayItem';
import Section from './Section';

class ReviewSection {
  private readonly _displayItems: Array<DisplayItem> = new Array<DisplayItem>();
  private readonly _identifier: string;
  private readonly _title: string;
  private readonly _section: Section;
  constructor(identifier: string, title: string, section: Section) {
    this._identifier = identifier;
    this._title = title;
    this._section = section;
  }

  addDisplayItem(item: DisplayItem): void {
    this._displayItems.push(item);
  }

  get displayItems(): Array<DisplayItem> {
    return this._displayItems;
  }

  get identifier(): string {
    return this._identifier;
  }

  get title(): string {
    return this._title;
  }

  get releasedByProctor(): boolean {
    return this._section.releasedByProctor;
  }
}

export default ReviewSection;
